import React from 'react'
import { motion, AnimatePresence } from 'framer-motion'
import { Download, X } from 'lucide-react'
import { usePWA } from '../../contexts/PWAContext'

export const InstallPrompt: React.FC = () => {
  const { isInstallable, showInstallPrompt, dismissInstallPrompt } = usePWA()

  return (
    <AnimatePresence>
      {isInstallable && (
        <motion.div
          initial={{ opacity: 0, y: 50, scale: 0.95 }}
          animate={{ opacity: 1, y: 0, scale: 1 }}
          exit={{ opacity: 0, y: 50, scale: 0.95 }}
          className="fixed bottom-4 left-4 right-4 z-50 mx-auto max-w-sm"
        >
          <div className="rounded-lg bg-gradient-to-r from-amber-500 to-orange-500 p-4 shadow-lg backdrop-blur-sm">
            <div className="flex items-start gap-3">
              <div className="flex-shrink-0">
                <Download className="h-5 w-5 text-white" />
              </div>
              <div className="flex-1 min-w-0">
                <h3 className="text-sm font-medium text-white">
                  Install Magic Money Help Bot
                </h3>
                <p className="text-xs text-amber-100 mt-1">
                  Add to your home screen for quick access and offline support
                </p>
              </div>
              <button
                onClick={dismissInstallPrompt}
                className="flex-shrink-0 p-1 hover:bg-white/20 rounded transition-colors"
                aria-label="Dismiss install prompt"
              >
                <X className="h-4 w-4 text-white" />
              </button>
            </div>
            <div className="flex gap-2 mt-3">
              <button
                onClick={showInstallPrompt}
                className="flex-1 bg-white text-amber-600 px-3 py-2 rounded-md text-sm font-medium hover:bg-amber-50 transition-colors"
              >
                Install App
              </button>
              <button
                onClick={dismissInstallPrompt}
                className="px-3 py-2 text-xs text-amber-100 hover:text-white transition-colors"
              >
                Maybe later
              </button>
            </div>
          </div>
        </motion.div>
      )}
    </AnimatePresence>
  )
}